import { SCORE_THRESHOLDS } from './constants';

export const getScoreClass = (score: number): 'high' | 'medium' | 'low' => {
  if (score >= SCORE_THRESHOLDS.HIGH) return 'high';
  if (score >= SCORE_THRESHOLDS.MEDIUM) return 'medium';
  return 'low';
};

export const isAnswerValid = (answer: string, minLength: number): boolean => {
  return answer.trim().length >= minLength;
};
